import { render } from "./ArchiveFilter.vue?vue&type=template&id=07c79123"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbarFilter/ArchiveFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07c79123"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07c79123', __exports__)) {
    console.log('reload')
    api.reload('07c79123', __exports__)
  }
  
  module.hot.accept("./ArchiveFilter.vue?vue&type=template&id=07c79123", () => {
    console.log('re-render')
    api.rerender('07c79123', render)
  })

}


export default __exports__